import React, { useState } from 'react'
import { Popup } from '../../../../../components/Popup'
import styled from 'styled-components'
import {
  DeleteHeader,
  DeleteMessage,
  PopupCancelButton,
  DeletionReason,
} from '../../styles'
import { Dustbin } from '../commonStyles'
import { Box, Button } from '../../../../../designSystem'
import { post } from '../../../../../lib/api'
import Loader from '../../../../../components/Loader'

const FlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
`

const OptionLabel = styled.label`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  margin-left: 4px;
`

const ReasonTextArea = styled.textarea`
  font-size: 14px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid #d4d4d4;
  padding: 8px;
  margin-top: 8px;
`

const options = [
  {
    label: 'Created by mistake',
    name: 'mistake',
    reason: 'Created by mistake',
  },
  {
    label: 'Others',
    name: 'others',
    reason: 'Others',
  },
]

const DeletionRequestPopup = ({
  handleClose,
  setDeletionOption,
  deletionOption,
  handleRefresh,
  chapterId,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const handleDeleteRequest = () => {
    if(isLoading) return
    setIsLoading(true)
    post('/approval_requests/create_approval_request?is_novel=1', {
      data: {
        request_type: 'chapter_deletion_request',
        creation_reason: deletionOption?.reason,
        status: 'PENDING',
        created_by: localStorage.getItem('uid'),
        entity_id: chapterId,
      },
    }).then(() =>{
      setIsLoading(false)
      handleClose()
      handleRefresh()
    })
  }
  return (
    <Popup
      show
      close={handleClose}
      renderActions={
        <>
          <PopupCancelButton
            className="action-button"
            type="button"
            onClick={handleClose}
          >
            Close
          </PopupCancelButton>
          <Button
            variant="fillDanger"
            disabled={deletionOption?.reason === '' || !deletionOption?.reason}
            onClick={handleDeleteRequest}
          >
            {isLoading ? <Loader size="xs" invertColor noPadding/> : 'Delete'}
          </Button>
        </>
      }
    >
      <Dustbin />
      <DeleteHeader>Delete this chapter?</DeleteHeader>
      <br />
      <DeleteMessage>
        Are you sure you want to delete this chapter? Our team will review it
        once and proceed with your request.
      </DeleteMessage>
      <DeletionReason>
        Let us know why you want to delete this chapter?
      </DeletionReason>
      <FlexContainer>
        {options?.map((option) => (
          <Box key={option?.name} flex="0 0 48%" mt={8}>
            <input
              type="radio"
              id={option?.name}
              name="approve"
              value={option?.reason}
              onChange={() =>
                setDeletionOption({
                  option: option?.name,
                  reason: option?.name === 'others' ? '' : option?.reason,
                })
              }
            />
            <OptionLabel for={option?.name}>{option?.label}</OptionLabel>
          </Box>
        ))}
      </FlexContainer>
      {deletionOption?.option === 'others' && (
        <ReasonTextArea
          placeholder="Please Describe......"
          value={deletionOption?.reason || ''}
          onChange={(e) =>
            setDeletionOption({ option: 'others', reason: e.target.value })
          }
          rows={4}
        ></ReasonTextArea>
      )}
    </Popup>
  )
}

export default DeletionRequestPopup
